import listButtonClickHandler from './esm/listButtonClickHandler'

window.addEventListener('load', () => {
  listButtonClickHandler()
})
